var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowStockColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8169 14.0997C22.8169 13.8322 22.7107 13.5758 22.5216 13.3867C22.3325 13.1976 22.076 13.0913 21.8086 13.0913C21.5412 13.0913 21.2847 13.1976 21.0956 13.3867C20.9065 13.5758 20.8003 13.8322 20.8003 14.0997V16.4188L14.8827 9.47573C14.7283 9.29531 14.5153 9.17515 14.281 9.13642C14.0467 9.09768 13.8063 9.14285 13.6021 9.26398L9.29653 11.8957L4.80945 6.51123C4.7247 6.40927 4.6207 6.325 4.50339 6.26323C4.38607 6.20147 4.25774 6.16341 4.12572 6.15124C3.9937 6.13906 3.86057 6.15302 3.73394 6.19229C3.60731 6.23157 3.48966 6.2954 3.3877 6.38015C3.28574 6.4649 3.20147 6.56889 3.1397 6.68621C3.07793 6.80352 3.03987 6.93185 3.0277 7.06388C3.01553 7.1959 3.02948 7.32902 3.06876 7.45565C3.10803 7.58228 3.17187 7.69994 3.25661 7.8019L8.29828 13.8519C8.45179 14.0365 8.66611 14.1602 8.9027 14.2009C9.13929 14.2415 9.38262 14.1964 9.58895 14.0737L13.9046 11.4823L19.5802 18.133H16.7669C16.4995 18.133 16.243 18.2392 16.0539 18.4283C15.8648 18.6174 15.7586 18.8739 15.7586 19.1413C15.7586 19.4088 15.8648 19.6652 16.0539 19.8543C16.243 20.0434 16.4995 20.1497 16.7669 20.1497H21.8086C21.9327 20.1466 22.0554 20.1228 22.1716 20.0791L22.3128 19.9984C22.3653 19.9719 22.4159 19.9416 22.464 19.9077C22.5192 19.8578 22.5668 19.8 22.6052 19.7363C22.639 19.6916 22.6693 19.6444 22.6959 19.5951C22.7206 19.5406 22.7376 19.4829 22.7463 19.4237C22.7872 19.3348 22.8112 19.239 22.8169 19.1413V14.0997Z",
    fill: "#1E1E1E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.691406,
    y: 11.8525,
    width: 4.14857,
    height: 9.68,
    rx: 2.07429,
    fill: "#ED5E69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53125,
    y: 15.3097,
    width: 4.14857,
    height: 6.22286,
    rx: 2.07429,
    fill: "#ED5E69"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3711,
    y: 14.6183,
    width: 4.14857,
    height: 6.91429,
    rx: 2.07429,
    fill: "#ED5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowStockColor);
export default __webpack_public_path__ + "static/media/low-stock-color.c9f3ec7cfc297395483cfa83f6158b40.svg";
export { ForwardRef as ReactComponent };